<template>
  <div>
    <yvalues :yvalues="yvalues" :numberfields="numberfields" @ychange="ychange"></yvalues>
    <div>
      <barchart ref="bar" v-if="charttype==='bar'" :chartdata="tdata" :options="options"></barchart>
      <piechart ref="pie" v-if="charttype==='pie'" :chartdata="tdata" :options="options"></piechart>
      <linechart ref="line" v-if="charttype==='line'" :chartdata="tdata" :options="options"></linechart>
      <singleclct v-if="(charttype==='sum') && (refreshsum==true)"
          :thedata="thedata || []"
          tabletitle=""
          collection=""
          searchval=""
          :ifheaderoperate="false"
          :iffootermore="false"
        ></singleclct>
    </div>
    <xfield :xfield="xfield" :xfields="xfields" @xchange="xchange"></xfield>
    <p>
      <el-radio v-model="charttype" label="bar">bar</el-radio>
      <el-radio v-model="charttype" label="line">line</el-radio>
      <el-radio v-model="charttype" label="pie">pie</el-radio>
      <el-radio v-model="charttype" label="sum">sum</el-radio>
    </p>
    <el-button v-show="!$store.state.ifremotechart" @click="callremote">查看全局图表</el-button>
  </div>
</template>
<script>
import { chartdataxy, chartdatagroup } from "@/components/utility/indexdb";
import xfield from "./xfield";
import yvalues from "./yvalues";
import barchart from "./charttype/bar";
import linechart from "./charttype/line";
import piechart from "./charttype/pie";
import singleclct from "@/components/news/singleclct.vue";
//import ChartDataLabels from "chartjs-plugin-datalabels";
import palette from "google-palette";
export default {
  //props: ["xfield", "xfields", "yvalues", "numberfields", "chartdatagroup"],
  components: { barchart, linechart, piechart, xfield, yvalues,singleclct },
  mounted() {
    // console.log()
    let self = this;
    // setTimeout(function() {
      self.datarender( self.charttype);
      // self.$refs[self.charttype].render();
    // }, 0);

    //this.chartprocess(this.chartdatagroup, this.charttype);
    // this.$refs[this.charttype].render();
  },

  watch: {
    //当数据变化时调用图表
    chartdatagroup: {
      handler: function(newval, oldVal) {
        this.datarender(this.charttype);
        // this.$refs[this.charttype].render();
      },
      deep: true
    }
  },

  computed: {
    // dataready() {
    //   return this.$store.state.clct && this.xfield != null;
    // },


    charttype: {
      get: function() {
        return this.$store.state.charttype;
      },
      set: function(val) {
        this.$store.commit("setcharttype", val);
      }
    },

    chartdataxy() {
      return this.$store.state.chartdataxy;
    },
 
    chartdatagroup() {
      return this.$store.state.chartdatagroup;
    },
    xfields() {
      return this.$store.state.xfields;
    },
    xfield() {
      return this.$store.state.xfield;
    },
    numberfields() {
      return this.$store.state.numberfields;
    },
    yvalues() {
      return this.$store.state.yvalues;
    }
  },
  methods: {
    callremote() {
      this.$axios.fetchremotechartdata("group");
    },
    renewchartgroup() {
      // return new Promise((resolve, reject) => {
      // if (this.xfield && this.yvalues) {
      chartdataxy(this.xfield, this.yvalues).then(doc => {
        chartdatagroup(this.xfield, this.yvalues, doc);
      });
      // }
      // chartdatagroup(this.xfield, this.yvalues)
      // });
    },
    xchange(val) {
      this.$store.commit("setxfield", val);
      this.renewchartgroup();
    },
    ychange(ar) {
      this.$store.commit("setyvalues", ar);
      this.renewchartgroup();
    },
    datarender(charttype){
      // 数据显示的模式
      if(charttype === "sum"){
        this.thedata["doc"]=this.$store.state.chartdataxy
        let fields=JSON.parse(JSON.stringify(this.numberfields))
        let xobj=this.xfields.find(obj=>{
          return obj.name==this.xfield
        })

        fields.unshift(xobj)

        this.thedata["fields"]=fields

        this.refreshsum=false;
        // this.refreshsum=true
        setTimeout(()=>{this.refreshsum=true;},0)
        
      }
      //图表显示的模式
      else{
        
        // console.log(this.$refs[this.charttype])
        let self=this
        setTimeout(()=>{
          self.chartprocess(charttype)
          self.$refs[charttype].render();
        },0)
        
      }
    },

    chartprocess(charttype) {

      //后面代码for chart
      let datas =this.chartdatagroup.datas;
      let datasets = [];
      let dataobj = {};
      for (let i = 0; i < datas.length; i++) {
        dataobj.data = datas[i];
        if (charttype === "line" || charttype === "bar") {
          dataobj.backgroundColor = "#" + palette("mpn65", datas.length)[i]; //需与yvalues中的color定义一致
        }
        if (charttype === "pie") {
          dataobj.backgroundColor = palette(
            "mpn65",
            dataobj.data.length > 65 ? 65 : dataobj.data.length
          ).map(function(hex) {
            return "#" + hex;
          });
        }

        let x = this.numberfields.find(obj => {
          return obj.name === this.yvalues[i];
        });
        if (x != undefined) {
          dataobj.label = x.title;
        }

        datasets.push(dataobj);
        dataobj = {};
      }

      this.tdata.datasets = datasets;
      this.tdata.labels = this.chartdatagroup.labels;
    }
  },

  data() {
    var currentval = "";
    var self = this;
    return {
      //thedata for sum
      thedata:{doc:[],fields:[]},
      refreshsum:false,

      tdata: {
        datasets: [],
        // [
        //   {
        //     data: [],
        //     backgroundColor: "red"
        //   },

        //   {
        //     data: [],
        //     backgroundColor: "blue"
        //   }
        // ],
        labels: []
      },
      options: {
        // plugins: {
        //   datalabels: {
        //     color: "black",
        //     anchor: "end",
        //     align: "top",
        //     formatter: function(value, context) {
        //       return Math.ceil(value);
        //     }
        //   }
        // },
        animation: { duration: 500, easing: "easeInQuad" },
        maintainAspectRatio: false,
        onClick: function() {
          self.$store.commit("setchartval", currentval);
        },

        tooltips: {
          intersect: false,
          mode: "point", //"index"
          callbacks: {
            title:function(){return ""},
            beforeLabel: function(tooltipItem, myData) {
              // console.log(tooltipItem)
              let theindex = tooltipItem.index;
              currentval=myData.labels[theindex]
              // var label = tooltipItem.xLabel||''
              // if (label) {
              // 	label += ': ';
              // }
              // label +=tooltipItem.yLabel;
              //console.log(myData)
              return currentval;

              //return tooltipItem.xLabel+":"+tooltipItem.yLabel;
            },
            label:function(tooltipItem, myData){
               let theyvalue=myData.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
              return new Intl.NumberFormat().format(theyvalue)
              }
          }
        },
        legend: { display: false },
        title: {
          display: false,
          text: "表格数据图"
        },
        scales: {
          xAxes: [
            {
              ticks: {
                callback: function(value) {
                  if(value.length>5){return value.substring(0, 4)}
                  else{return value}
                }
              }
            }
          ],
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: true
              },
              ticks: {
                //min: 0,
                beginAtZero: true
              }
            }
          ]
        }
      }
    };
  }
};
</script>






// WEBPACK FOOTER //
// src/components/presentation/chart/thechart.vue